var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 6.234,
    x2: 32,
    y2: 56.951,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 6.234,
    x2: 32,
    y2: 56.951,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 21.5,
    x2: 32,
    y2: 26.336,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 29.333,
    x2: 32,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 32,
    y1: 37,
    x2: 32,
    y2: 41.337,
    gradientUnits: "userSpaceOnUse",
    id: "color-5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,12h-34c-1.7,0 -3,1.3 -3,3v34c0,1.7 1.3,3 3,3h34c1.7,0 3,-1.3 3,-3v-34c0,-1.7 -1.3,-3 -3,-3zM50,49c0,0.6 -0.4,1 -1,1h-34c-0.6,0 -1,-0.4 -1,-1v-34c0,-0.6 0.4,-1 1,-1h34c0.6,0 1,0.4 1,1z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,8h-38c-2.8,0 -5,2.2 -5,5v38c0,2.8 2.2,5 5,5h38c2.8,0 5,-2.2 5,-5v-38c0,-2.8 -2.2,-5 -5,-5zM54,51c0,1.7 -1.3,3 -3,3h-38c-1.7,0 -3,-1.3 -3,-3v-38c0,-1.7 1.3,-3 3,-3h38c1.7,0 3,1.3 3,3z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,25c0,0.6 -0.4,1 -1,1h-22c-0.6,0 -1,-0.4 -1,-1v-2c0,-0.6 0.4,-1 1,-1h22c0.6,0 1,0.4 1,1z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,33c0,0.6 -0.4,1 -1,1h-22c-0.6,0 -1,-0.4 -1,-1v-2c0,-0.6 0.4,-1 1,-1h22c0.6,0 1,0.4 1,1z",
    fill: "url(#color-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,41c0,0.6 -0.4,1 -1,1h-22c-0.6,0 -1,-0.4 -1,-1v-2c0,-0.6 0.4,-1 1,-1h22c0.6,0 1,0.4 1,1z",
    fill: "url(#color-5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.21f272e19a4cd14924e9ccf9918c86da.svg";
export { ForwardRef as ReactComponent };